/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import FAQS from 'views/common/components/Logical/Layout/Footer/NeedHelp/FAQS';
import ContactForm from 'views/common/components/Logical/Layout/Footer/NeedHelp/ContactForm';
import axios, { API } from 'lib/config/axios';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import { useDispatch } from 'react-redux';
import { setLoading } from 'redux/features/ui-slice';

const ContactUsContent = ({
  userId,
  onClose,
  leadCategoryId,
  isContactUsPage,
}) => {
  const dispatch = useDispatch();
  const handleErrorResponse = useErrorsHandler();
  const [data, setData] = useState({});

  useEffect(() => {
    async function fetchData() {
      dispatch(setLoading(true));
      try {
        const { data } = await axios.get(API.contactUs, {
          params: {
            'contact_info[referring_page]': window.location.href,
            'contact_info[case]': null,
          },
        });
        setData(data);
      } catch (error) {
        handleErrorResponse(error);
      } finally {
        dispatch(setLoading(false));
      }
    }
    fetchData();
  }, []);

  return (
    <>
      <FAQS
        faq_items={data.faq_items}
        isContactUsPage={isContactUsPage && isContactUsPage}
      />

      <ContactForm
        contactInfo={{
          ...data.contact_info,
          category_id:
            leadCategoryId == null
              ? data.contact_info?.category_id
              : leadCategoryId,
        }}
        leadCategoryId={leadCategoryId}
        leadCategories={data.lead_categories}
        leadTypes={data.lead_types}
        userId={userId}
        onClose={onClose}
        isContactUsPage={isContactUsPage && isContactUsPage}
      />
    </>
  );
};

export default ContactUsContent;
